/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";
export const GET_ASSET_DETAIL = gql`
query GetAsset($tokenId: String!, $tokenGroup: String!, $storeId: String) {
  getAsset(tokenId: $tokenId, tokenGroup: $tokenGroup, storeId: $storeId) {
    title
    subtitle
    serialNo
    type
    tokenGroup
    tag
    category
    thumbnail
    img
    price {
      type
      amount
      currency
      sale {
        salePrice
        saleEndDate
      }
      symbol
    }
    symbol
    attrs {
      name
      val
      disp_type
      disp_val
    }
    media {
      type
      src
      thumbnail
    }
    digitalTwin
    nftProvenance {
      title
      from {
        name
        link
        address
        authProofUrl
      }
      to {
        name
        link
        address
        authProofUrl
      }
      tx_proof
      date
      meta
    }
    networkType
    hasProvenance
    creator {
      name
      link
      address
      authProofUrl
    }
    owner {
      name
      link
      address
      authProofUrl
    }
    claimEnabled
    state
    tx_proof
    toBeClaimedBy {
      email
      voucherCode
      claimType
      exp
    }
  }
  viewInIpfs(tokenId: $tokenId, tokenGroup: $tokenGroup)
}
`;
